import { createContext } from 'react';

const ClampContext = createContext({ clampValues: false });
const ClampContextProvider = ClampContext.Provider;

export { ClampContext, ClampContextProvider };
